<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("pilates member module settings") }}
      </h1>
    </div>

    <!-- <div class="title is-5">{{ $t("availability schedule") }}</div>
    <div class="button is-primary is-rounded" @click="availability">
      <span class="icon"><i class="fa fa-calendar"></i></span>
      <span>{{ $t("availability") }}</span>
    </div> -->

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("account module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_every_customer_has_account"
            name="chk_every_customer_has_account"
            v-model="meta.every_customer_has_account"
          />
          <label for="chk_every_customer_has_account">{{
            $t("every customer has an account")
          }}</label>
          <div
            class="button is-rounded is-primary is-small"
            @click="check_customer_account_existance"
          >
            <span class="icon"><i class="fa fa-check"></i></span>
            <span>{{ $t("check") }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('account type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/type/catalog"
            name_field="name"
            value_field="type_id"
            @selected="account_type_changed"
            ref="account_type_dropdown"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('movement type to apply on promotion buying')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="movement_type_changed"
            ref="movement_type_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('movement type to apply on payment registered')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="payment_movement_type_changed"
            ref="payment_movement_type_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_little_jar"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_little_jar">{{
            $t("integrate")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for member photos')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for qr codes')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_qr_changed"
            ref="drive_qr_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("outbox module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_outbox"
            name="chk_integrate_outbox"
            v-model="meta.integrate_outbox"
          />
          <label for="chk_integrate_outbox">{{ $t("integrate") }}</label>
        </div>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_attach_rules_to_qr_mail"
            name="chk_attach_rules_to_qr_mail"
            v-model="meta.attach_rules_to_qr_mail"
          />
          <label for="chk_attach_rules_to_qr_mail">{{
            $t("attach rules to qr mail")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('template for qr code')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="qr_template_changed"
            ref="qr_template_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("rules pdf") }}</label>
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop pdf here')"
            endpoint_url="/pilates_member/rules"
            @error="error_uploading"
            @success="success_uploading"
            :allow_multiple="false"
          />
        </div>
        <div class="tags has-addons" v-if="meta && meta.rules_pdf">
          <span class="tag is-primary">
            <span class="icon"><i class="fa fa-file-text"></i></span>
          </span>
          <span class="tag">
            <span>{{ meta.rules_pdf.file.name }}</span>
          </span>
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("fel module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_fel"
            name="chk_integrate_fel"
            v-model="meta.integrate_fel"
          />
          <label for="chk_integrate_fel">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('fel emitter')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/fel/emitter/catalog"
            name_field="name"
            value_field="emitter_id"
            @selected="fel_emitter_changed"
            ref="fel_emitter_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("default country") }}</label>
          <input type="text" class="input" v-model="meta.fel_default_country" />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("default zip code") }}</label>
          <input
            type="text"
            class="input"
            v-model="meta.fel_default_zip_code"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('template for billing')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="billing_template_changed"
            ref="billing_template_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="container mt-5 mb-5">
      <h5 class="title is-5 pt-3">{{ $t("validations") }}</h5>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{
              $t("booking can be made before (minutes)")
            }}</label>
            <input
              type="text"
              class="input"
              v-model="meta.booking_making_time_limit"
            />
          </div>
        </div>
        <!-- <div class="column">
          <div class="field">
            <label class="label">{{ $t("cancel booking time limit") }}</label>
            <input
              type="text"
              class="input"
              v-model="meta.fel_default_country"
            />
          </div>
        </div> -->
      </div>
    </div>

    <promotions-datatable />

    <div class="container mt-5">
      <p class="buttons is-pulled-right">
        <button
          class="button is-secondary is-rounded"
          @click="add_payment_method"
        >
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </p>
      <h5 class="title is-5 pt-3">{{ $t("payment methods") }}</h5>
      <table
        class="table is-bordered is-fullwidth"
        v-if="meta && meta.payment_methods"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("percentage of use") }}</th>
            <th>{{ $t("options") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rsrc, ridx) in meta.payment_methods" :key="ridx">
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.payment_methods[ridx].name"
              />
            </td>
            <td>
              <input
                type="text"
                class="input"
                v-model="meta.payment_methods[ridx].percentage_of_use"
              />
            </td>
            <td>
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_show_shopping_cart' + ridx"
                  v-model="meta.payment_methods[ridx].ask_for_document_number"
                />
                <label :for="'chk_show_shopping_cart' + ridx">{{
                  $t("ask for document number")
                }}</label>
              </div>
            </td>
            <td>
              <button
                class="button is-secondary has-text-danger is-rounded"
                @click="meta.payment_methods.splice(ridx, 1)"
                :data-tooltip="$t('delete')"
              >
                <span class="icon">
                  <i class="fa fa-trash"></i>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <availability-modal ref="availability_modal" @save="update_availability" />
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import PromotionsDatatable from "./promotion_datatable/Index.vue";
import AvailabilityModal from "./availability_modal/Index.vue";

export default {
  name: "Gym_memberSettings",
  components: {
    GenericDropdown,
    PromotionsDatatable,
    AvailabilityModal,
    GenericUploader,
  },
  data() {
    return {
      meta: {
        payment_methods: [],
      },
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    account_type_changed(value) {
      this.meta.account_type_id = value.type_id;
    },
    movement_type_changed(value) {
      this.meta.movement_type_id = value.movement_type_id;
    },
    payment_movement_type_changed(value) {
      this.meta.payment_movement_type_id = value.movement_type_id;
    },
    drive_changed(value) {
      this.meta.drive_id = value.drive_id;
    },
    drive_qr_changed(value) {
      this.meta.drive_qr_id = value.drive_id;
    },
    qr_template_changed(value) {
      this.meta.qr_template_id = value.template_id;
    },
    availability() {
      let v = this;
      v.$refs.availability_modal.show_modal(v.meta);
    },
    update_availability(data) {
      let v = this;
      v.meta.availability = data;
    },
    error_uploading(error) {
      console.error("error_uploading", error);
      // let v = this;
      // v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      let server_response = JSON.parse(response.serverId);
      v.meta.rules_pdf = server_response;
      // v.$refs.generic_uploader.clear();
      // v.init();
    },
    add_payment_method() {
      let v = this;
      v.meta.payment_methods.push({
        name: "",
        ask_for_document_number: false,
      });
    },
    check_customer_account_existance() {
      let v = this;
      post("/pilates_member/account-existance")
        .then((response) => {
          success_message(v.$t("every customer has an account"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
    fel_emitter_changed(value) {
      this.meta.fel_emitter_id = value.emitter_id;
    },
    billing_template_changed(value) {
      this.meta.billing_template_id = value.template_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.account_type_id) {
            v.$refs.account_type_dropdown.set_value(conf.account_type_id);
          }
          if (conf.movement_type_id) {
            v.$refs.movement_type_dropdown.set_value(conf.movement_type_id);
          }
          if (conf.payment_movement_type_id) {
            v.$refs.payment_movement_type_dropdown.set_value(
              conf.payment_movement_type_id
            );
          }
          if (conf.drive_id) {
            v.$refs.drive_dropdown.set_value(conf.drive_id);
          }
          if (conf.drive_qr_id) {
            v.$refs.drive_qr_dropdown.set_value(conf.drive_qr_id);
          }
          if (conf.qr_template_id) {
            v.$refs.qr_template_dropdown.set_value(conf.qr_template_id);
          }

          if (conf.fel_emitter_id) {
            v.$refs.fel_emitter_dropdown.set_value(conf.fel_emitter_id);
          }

          if (conf.billing_template_id) {
            v.$refs.billing_template_dropdown.set_value(
              conf.billing_template_id
            );
          }

          v.meta.payment_methods = conf.payment_methods || [];
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
